/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".table-padded{overflow:visible!important}  .table-padded .datatable-header-cell-label{border:none;font-size:.81rem;color:rgba(90,99,126,.49);letter-spacing:1px;padding:.3rem 1.1rem;text-transform:uppercase}  .table-padded .datatable-body-cell{padding:.9rem 1.1rem;background-color:#fff;border:none;border-right:1px solid rgba(0,0,0,.03);display:flex;align-items:center;align-content:center}  .table-padded .datatable-body-cell-label{line-height:30px}  .table-padded .datatable-body-cell-label .badge.badge-dark{font-size:15px}"];
export { styles as styles };
